<template>
  <!--内容管理-->
    <div id="contentManger" style="padding-bottom: 10px">
      <div class="allMenuHead">
        <div v-if="$childMenu.indexOf('文章日志') >= 0" :class="step === 1 ? 'active' : ''" @click="toUrl('burialPointArticleLog', 1)" class="d_i headTab p_r">文章日志<div class="p_a"></div></div>
        <div v-if="$childMenu.indexOf('搜索记录') >= 0" :class="step === 2 ? 'active' : ''" @click="toUrl('burialPointSearchHistory', 2)"  class="d_i headTab p_r">搜索记录<div class="p_a"></div></div>
        <div v-if="$childMenu.indexOf('行为日志') >= 0" :class="step === 3 ? 'active' : ''" @click="toUrl('burialPointActionHistory', 3)" class="d_i headTab p_r">行为日志<div class="p_a"></div></div>
      </div>
      <div class="allHeaderRouter">
        <transition name="fadeLeft">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </template>
  
  <script>
  let Time
  let reflashTime
  export default {
    name: 'contentManger',
    data () {
      return {
        step: 1,
      }
    },
    created () {
      Time = setInterval(p => {
        if (window.location.href.indexOf('burialPointArticleLog') >= 0) {
          this.step = 1
        } else if (window.location.href.indexOf('burialPointSearchHistory') >= 0) {
          this.step = 2
        } else if (window.location.href.indexOf('burialPointActionHistory') >= 0) {
          this.step = 3
        }
      }, 100)
    },
    destroyed () {
      clearInterval(Time)
    },
    methods: {
      toUrl (url, num) {
        this.step = num
        this.$router.push(url)
      },
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/components/pages/burialPointRecord/burialPointRecord.vue